import React from 'react';
import { Link } from 'react-router-dom';
import { Video, Code2, ArrowRight } from 'lucide-react';
import { mockData } from '../data/mock';
import BrandLogo from './BrandLogo';

const RoleChooser = () => {
  const { hero } = mockData;

  return (
    <section id="hero" className="relative py-20 bg-gradient-to-b from-black via-slate-950 to-slate-900 overflow-hidden">
      <div className="absolute -top-24 -left-24 h-64 w-64 rounded-full blur-3xl opacity-30" style={{ backgroundColor: '#f97316' }}></div>
      <div className="absolute -bottom-32 -right-16 h-72 w-72 rounded-full blur-3xl opacity-20 bg-blue-600"></div>
      <div className="absolute inset-0 opacity-30">
        <img
          src={hero.backgroundVideo}
          alt="Background"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-slate-900/80"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="sr-only">{hero.title}</h1>
          <BrandLogo className="mb-8" />
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            {hero.description}
          </p>
          <div className="w-16 h-1 rounded-full mx-auto mt-6" style={{ backgroundColor: '#f97316' }}></div>
        </div>

        <div className="text-center mb-10">
          <p className="text-sm uppercase tracking-[0.3em] text-gray-400 mb-3">Deux univers</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Choisissez votre univers
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Vidéaste ou développeur web & e-commerce : la même exigence, deux expertises.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <Link
            to="/web-dev"
            className="group relative rounded-2xl p-8 sm:p-10 border border-orange-500/40 bg-slate-900/70 hover:bg-slate-900/90 transition-all duration-300 overflow-hidden shadow-xl shadow-orange-500/10"
          >
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-transparent to-transparent"></div>
            </div>
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-11 w-11 rounded-full flex items-center justify-center bg-blue-600">
                  <Code2 className="h-5 w-5 text-white" />
                </div>
                <span className="text-sm uppercase tracking-[0.2em] text-orange-300">Priorité</span>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-3">
                Sites rapides & boutiques qui vendent
              </h3>
              <p className="text-gray-300 mb-6">
                Une expérience claire, des performances solides et une conversion pensée pour votre business.
              </p>
              <div className="flex items-center gap-2 text-white font-medium">
                Découvrir l'offre web
                <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>

          <Link
            to="/realisations/video"
            className="group relative rounded-2xl p-8 sm:p-10 border border-slate-800 bg-slate-900/60 hover:bg-slate-900/80 transition-all duration-300 overflow-hidden"
          >
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 via-transparent to-transparent"></div>
            </div>
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-11 w-11 rounded-full flex items-center justify-center" style={{ backgroundColor: '#f97316' }}>
                  <Video className="h-5 w-5 text-white" />
                </div>
                <span className="text-sm uppercase tracking-[0.2em] text-gray-400">Vidéaste</span>
              </div>
              <h3 className="text-2xl font-semibold text-white mb-3">
                Films d'entreprise, mariages, drone
              </h3>
              <p className="text-gray-300 mb-6">
                Des images fortes, un récit clair et une production fluide pour valoriser votre marque.
              </p>
              <div className="flex items-center gap-2 text-white font-medium">
                Voir les réalisations vidéo
                <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RoleChooser;
